<template>

    <div
        class="c-summary_col"
        :class="{ ['c-summary_col--' + type] : type }">
        <h4 class="c-summary_col__name">{{ title }}</h4>
        <table class="c-summary_col__table">
            <tbody>
            <slot></slot>
            </tbody>
        </table>
    </div>

</template>


<script>

export default {

    name: 'SummaryCol',

    props: {
        title: String,
        type: {
            type: String,
            default: '100w'
        }
    },

}

</script>


<style lang="scss">

@import '~Style/_utils.scss';

.c-summary_col {
    margin-bottom: 3rem;
    flex-grow: 1;

    &--50w {
        width: 50%;
    }
    &--100w {
        width: 100%;
    }
    @include bp($screen-lg) {
        width: 100%;
    }
    &__name {
        font-weight: bold;
        color: $c-third;
        margin-bottom: 2rem;
    }
    &__table {
        width: 100%;
        table-layout: fixed;
    }
}

</style>
